import React from 'react';
import Box from '@mui/material/Box';
import MainLogoWhite from '@components/layout/Header/MainLogoWhite';
import ContactAndRequestButtons from '@components/layout/Header/ContactAndRequestButtons';
import MenuCloseIcon from '@components/layout/Header/MenuCloseIcon';

interface ModalHeaderProps {
  handleClose: () => void;
}

export default function ModalHeader({ handleClose }: ModalHeaderProps): React.JSX.Element {
  return (
    <Box className="flex justify-between items-center mt-16 mr-36 ml-16 md:max-lg:flex-wrap">
      <MainLogoWhite />
      <Box className="flex items-center md:max-lg:mt-8 md:max-lg:mx-auto">
        <Box>
          <ContactAndRequestButtons />
        </Box>
        <MenuCloseIcon onClick={handleClose} />
      </Box>
    </Box>
  );
}
